import useSlugExtractor from "@hooks/useSlugExtractor"

import TableViewTab from "@organisms/Table/TableViewControls/TableViewTab/TableViewTab"
import TableViewTabs from "@organisms/Table/TableViewControls/TableViewTabs/TableViewTabs"

import { getCategoryTabTitles } from "@pages/Catalogs/BrandItems/BrandItems.utils"
import { BrandItemsTableViewTabsProps } from "@pages/Catalogs/BrandItems/views/BrandItemsTableView/BrandItemsTableView.types"

import { CATALOG_ENDPOINTS } from "@endpoints/catalogs"

export default function BrandItemsTableViewTabs(props: BrandItemsTableViewTabsProps) {
    const { catalogId, brandParam, categories } = props

    const categoryTabTitles = getCategoryTabTitles(categories)

    const [listEndpoint, countEndpoint] = useSlugExtractor([CATALOG_ENDPOINTS.ITEMS, CATALOG_ENDPOINTS.ITEMS_COUNT])

    // Catalog and brand scope every tab's listing; the brand param carries a real id or the
    // null-scope sentinel for the brandless page, and category tabs add their own filter on top.
    const scopeKwargs: [string, string][] = [
        ["catalog", catalogId],
        ["brand", brandParam],
    ]

    return (
        <TableViewTabs>
            <TableViewTab
                id="all"
                title="All"
                phase="active"
                endpointKwargs={scopeKwargs}
                isDefaultActiveTabForPhase={true}
                listEndpoint={listEndpoint}
                countEndpoint={countEndpoint}
            />
            {categories.map((category) => (
                <TableViewTab
                    key={category.id}
                    id={`category_${category.id}`}
                    title={categoryTabTitles.get(category.id) ?? category.name}
                    phase="active"
                    endpointKwargs={[...scopeKwargs, ["category", String(category.id)]]}
                    isDefaultActiveTabForPhase={false}
                    listEndpoint={listEndpoint}
                    countEndpoint={countEndpoint}
                    // A catalog can expose dozens of category tabs; per-tab counts would fan out a
                    // count request per category on every keyword change.
                    hideCount={true}
                />
            ))}
        </TableViewTabs>
    )
}
